export const HUD_MESSAGE_ANNOUNCEMENT_DURATION_MS = 3000;
export const HUD_MESSAGE_HINT_DURATION_MS = 6000;
export const HUD_MESSAGE_FADE_IN_MS = 200;
export const HUD_MESSAGE_FADE_OUT_MS = 400;
export const HUD_MESSAGE_SLOT_HEIGHT = 32;
export const HUD_MESSAGE_BOTTOM_PADDING = 8;
export const HUD_MESSAGE_SLOT_GAP = 4;
export const HUD_MESSAGE_FONT_SIZE = 18;
export const HUD_MESSAGE_PADDING_X = 14;
export const HUD_MESSAGE_MIN_WIDTH = 320;
export const HUD_MESSAGE_SLIDE_DISTANCE = 16;
export const HUD_MESSAGE_BG_COLOR = "rgba(60, 60, 60, 0.80)";
export const HUD_MESSAGE_TEXT_COLOR = "#ffffff";
